type Props = {
  current: number;
  total?: number;
  label?: string;
};

export function IntakeProgress({ current, total = 5, label }: Props) {
  return (
    <div className="intake-progress">
      <div className="intake-progress__bars" aria-hidden="true">
        {Array.from({ length: total }, (_, index) => (
          <span
            key={index}
            className={`intake-progress__bar${
              index < current ? " intake-progress__bar--active" : ""
            }`}
          />
        ))}
      </div>
      {label && <p className="intake-progress__label">{label}</p>}
    </div>
  );
}
